import React, { useState, useEffect, useCallback } from 'react';
import Header from "../components/Header";
import { Row, Col, Container,Spinner } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import * as AuthenticateAPI from "../services/students";
import toast, { toastConfig } from 'react-simple-toasts';

const StudentEntriesHome = () => {

    const [studArray, setStudArray] = useState([]);
    const [items, setItems] = useState([]);
    const [loader, setLoader] = useState(false);

    toastConfig({
        render: message => <div style={{ backgroundColor: '#cc2427', 
        color: 'white', padding: 10, borderRadius: 10, fontSize: 18, 
        fontWeight: '700' }}>{message}</div>,
    })

    const fetchData = useCallback(async () => { 
        setLoader(true)
        try {
            await AuthenticateAPI.getStudentDetails().then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    setItems(res.data)
                } else {
                    if (res.status === 204) {
                        return
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }
    }, [])

    useEffect(() => {
        fetchData();
    }, [fetchData])

    useEffect(() => {

        let arrays = [];
        let i = 0;
        for (i = 0; i < items.length; i++) {
            let firstObj = items[i];
            let secondObj = items[i + 1] ? items[i + 1] : null;
            let thirdObj = items[i + 2] ? items[i + 2] : null;
            let val = [firstObj, secondObj, thirdObj];
            arrays.push(val);
            i += 2;
        }
        setStudArray(arrays);

        window.scrollTo({ top: 0, behaviour: "smooth" })


    }, [items])

    return (
        <>
            <Header title="Scholarship Applications" />
            {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                <Spinner animation="border" variant="primary" /> </div>}
            <section className="py-3 py-md-4 py-lg-5">
                <Container>
                    <Row>
                        <Col lg={12}>

                            <table className="table table-bordered table-striped text-center">
                                <thead className="bg-dark text-white">
                                    <tr>
                                        <th colSpan="3">STUDENT APPLICATIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {studArray.map((stud, ind) => {
                                        return <tr key={ind}>
                                            <td>
                                                <Link to={`/student-entries/${stud[0].firstName + " " + stud[0].lastName}?code=${stud[0].studentCode}`}>
                                                    {stud[0].firstName + " " + stud[0].lastName}
                                                </Link>
                                            </td>
                                            {stud[1] && <td>
                                                <Link to={`/student-entries/${stud[1].firstName + " " + stud[1].lastName}?code=${stud[1].studentCode}`}>
                                                    {stud[1].firstName + " " + stud[1].lastName}
                                                </Link>
                                            </td>}
                                            {stud[2] && <td>
                                                <Link to={`/student-entries/${stud[2].firstName + " " + stud[2].lastName}?code=${stud[2].studentCode}`}>
                                                    {stud[2].firstName + " " + stud[2].lastName}
                                                </Link>
                                            </td>}
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
}

export default StudentEntriesHome;